module.exports = require("codemirror/addon/display/placeholder");